import './pageTitle.css'

const PageTitle = (props)=>{

    
    return(
        <div className='PageTitle-Container'>
            <p className='PageTitle-text'>{props.title}</p>
            <p className='PageTitle-description'>{props.description}</p>

        </div>
    )
}

export default PageTitle